import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell from './OverviewCardShell';
import styles from './StandardOverview.module.css';

const WorkstreamsSetupCard = () => {
    const navigate = useNavigate();

    return (
        <OverviewCardShell highlight className={styles.workstreamsCard}>
            <p className={styles.cardEyebrow}>Workstreams</p>
            <p className={styles.cardStatus}>Not configured</p>
            <p className={styles.cardDescription}>
                Define how this project will be organised. Workstreams are required for VDR and Information Requests.
            </p>
            <button type="button" className={styles.primaryButton} onClick={() => navigate('/dataroom')}>
                Set up workstreams
            </button>
        </OverviewCardShell>
    );
};

export default WorkstreamsSetupCard;
